//cab-hub-tracking.table.ts

import {
    JsonItem, PickListItem
} from "../../shared/entities/pick-list/pick-list.entities";

import {
    TableColumnGroup,
    TableColumnVisibilityControllerV2
} from "../../shared/scripts/table-column-visibility";

import {
    plainToClass
} from "class-transformer";
import {
    CabHubActiveSurveyRow,
    CabHubCompletedSurveyRow,
    CabHubConnectionEntity,
    CabHubScope,
    CabHubTrackingPageVm
} from "./cab-hub-tracking.entities";
import {
    EditTable,
    EditTableConfig,
    EditTableSortColumn,
    IEditController
} from "../../shared/components/edit-table/edit-table";
import {
    TableRenderer,
    TableRenderType
} from "../../shared/components/edit-table/table-renderer";
import { getDisplayDate, GetMonthFromNumber } from "../../shared/scripts/date-functions";
import { GetSelectedDropdownValues, IFilter, InitializeFilterDropdown } from "../../shared/scripts/dropdown-functions";

//Admin Edit Table of all CAB-HUB Connections
export class CabHubConnectionsTable {
    tableConfig:
        EditTableConfig;

    editTable:
        EditTable;

    tableRenderer:
        TableRenderer;

    pickLists:
        JsonItem[];

    connectionList:
        CabHubConnectionEntity[];

    targetId:
        string;

    private readonly vm:
        CabHubTrackingPageVm;

    private readonly onAddConnection:
        () => void;

  
    constructor(
        targetId: string,
        vm: CabHubTrackingPageVm,
        editController: IEditController,
        onAddConnection: () => void
    ) {
        this.targetId =
            targetId;

        this.vm =
            vm;

        this.onAddConnection =
            onAddConnection;

        this.tableConfig = {
            tableId:
                "cab-hub-connections-table",

            tableVarName:
                "connectionTable.editTable",

            propertyIdName:
                "Id",

            itemDisplayName:
                "Connections",

            isEditable:
                true,

            isMultiselect:
                false,

            editController:
                editController,

            tableColumnGroups: [],

            filterTabs: [],

            columns: [
                {
                    data:
                        "CabMemberUserId",

                    title:
                        "CAB Member",

                    className:
                        "general text-left nowrap " +
                        "font-size12 table-column-md",

                    render:
                        (
                            data:
                                number
                        ): string => {

                            return this.tableRenderer
                                .renderDisplay(
                                    data,
                                    TableRenderType.Number,
                                    "pl-cab-member"
                                );
                        }
                },
                {
                    data:
                        "HubId",

                    title:
                        "Hub",

                    className:
                        "general text-left " +
                        "font-size12 nowrap",

                    render:
                        (
                            data:
                                number
                        ): string => {

                            return this.tableRenderer
                                .renderDisplay(
                                    data,
                                    TableRenderType.Number,
                                    "pl-short-hub"
                                );
                        }
                },
                {
                    data:
                        "StatusId",

                    title:
                        "Status",

                    className:
                        "general text-center " +
                        "font-size12 nowrap",

                    render:
                        (
                            data: number,
                            type: string
                        ): string => {

                            return this.renderStatus(
                                data,
                                type
                            );
                        }
                },
                {
                    data:
                        "StartDate",

                    title:
                        "Start Date",

                    className:
                        "general text-left " +
                        "font-size12 nowrap",

                    render:
                        (
                            data: string,
                            type: string
                        ): string => {

                            return this.renderDate(
                                data,
                                type
                            );
                        }
                },
                {
                    data:
                        "EndDate",

                    title:
                        "End Date",

                    className:
                        "general text-left " +
                        "font-size12 nowrap",

                    render:
                        (
                            data: string,
                            type: string
                        ): string => {

                            return this.renderDate(
                                data,
                                type
                            );
                        }
                },
                {
                    data:
                        "LastModifiedDate",

                    title:
                        "Last Updated",

                    className:
                        "general text-left " +
                        "font-size12 nowrap",

                    render:
                        (
                            data: string,
                            type: string
                        ): string => {

                            return this.renderDate(
                                data,
                                type
                            );
                        }
                },
                {
                    data:
                        "Id",

                    title:
                        "Connection",

                    className:
                        "general text-center " +
                        "font-size12 nowrap",

                    orderable:
                        false,

                    render:
                        (
                            data: number,
                            type: string
                        ): string => {

                            if (
                                type !==
                                "display"
                            ) {
                                return `${data ?? ""}`;
                            }

                            return `
                                <a class="
                                    btn
                                    btn-sm
                                    btn-primary
                                    detail-btn
                                    font-size11
                                "
                                   href="/secure/cab-hub/connection-details/${data}">
                                    View Details
                                </a>
                            `;
                        }
                },
                {
                    data:
                        "AdminNotes",

                    title:
                        "Check-in Notes",

                    visible:
                        false,

                    className:
                        "check-in-notes text-left " +
                        "font-size12 table-column-lg nowrap",

                    render:
                        (
                            data: string
                        ): string => {

                            return data?.trim() || "";
                        }
                },
                {
                    data:
                        "StartDate",

                    title:
                        "1-Month Check-in",

                    visible:
                        false,

                    render:
                        (
                            data: string,
                            type: string
                        ): string => {

                            return this.renderProjectedDate(
                                data,
                                1,
                                type
                            );
                        }
                },
                {
                    data:
                        "OneMonthCheckInNotes",

                    title:
                        "1-Month Notes",

                    visible:
                        false
                },
                {
                    data:
                        "StartDate",

                    title:
                        "6-Month Check-in",

                    visible:
                        false,

                    render:
                        (
                            data: string,
                            type: string
                        ): string => {

                            return this.renderProjectedDate(
                                data,
                                6,
                                type
                            );
                        }
                },
                {
                    data:
                        "SixMonthCheckInNotes",

                    title:
                        "6-Month Notes",

                    visible:
                        false
                }
            ],

            sortOrder: [
                new EditTableSortColumn(
                    4,
                    "desc"
                )
            ]
        };

        this.editTable =
            new EditTable(
                this.tableConfig
            );
    }


    public initialize():
        void {

        $(`#${this.targetId}`)
            .empty()
            .html(
                this.editTable
                    .generateHtml()
            );

        this.connectionList =
            plainToClass(
                CabHubConnectionEntity,
                this.vm.Connections ?? []
            );

        this.pickLists =
            plainToClass(
                JsonItem,
                this.vm.PickLists ?? []
            );

        this.tableRenderer =
            new TableRenderer(
                this.pickLists
            );

        this.editTable.initialize(
            this.connectionList,
            this.pickLists
        );

        this.initializeAddConnectionButton();

        this.customizeTableHeader();

        setTimeout(
            () =>
                this.editTable
                    .resizeTable(),
            100
        );
    }


    public updateTable(
        connections:
            CabHubConnectionEntity[]
    ): void {

        this.connectionList =
            plainToClass(
                CabHubConnectionEntity,
                connections ?? []
            );

        this.editTable.updateTable(
            this.connectionList
        );
    }


    public upsertConnection(
        connection:
            CabHubConnectionEntity
    ): void {

        const existingIndex =
            this.connectionList
                .findIndex(
                    item =>
                        item.Id ===
                        connection.Id
                );

        if (
            existingIndex >=
            0
        ) {
            this.connectionList[
                existingIndex
            ] =
                connection;
        }
        else {
            this.connectionList
                .push(
                    connection
                );
        }

        this.editTable.updateTable(
            this.connectionList
        );
    }


    private renderDate(
        data: string,
        type: string
    ): string {

        if (
            type !== "display" ||
            !data
        ) {
            return data ?? "";
        }

        return getDisplayDate(
            new Date(data)
        );
    }


    private renderStatus(
        data: number,
        type: string
    ): string {

        const display =
            this.tableRenderer
                .renderDisplay(
                    data,
                    TableRenderType.Number,
                    "pl-connection-status"
                );

        if (
            type !==
            "display"
        ) {
            return display;
        }

        const isActive =
            display
                .trim()
                .toLowerCase() ===
            "active";

        const className =
            isActive
                ? "cab-edit-table-active-pill"
                : "cab-edit-table-inactive-pill";

        return `
            <div class="${className}">
                ${display}
            </div>
        `;
    }


    private initializeAddConnectionButton():
        void {

        const buttonId =
            `${this.tableConfig.tableId}-add-connection`;

        const $buttonContainer =
            $(
                `#${this.tableConfig.tableId}_wrapper`
            ).find(
                ".dt-buttons"
            );

        $(`#${buttonId}`)
            .remove();

        const $addButton =
            $(`
                <button type="button"
                        id="${buttonId}"
                        class="
                            btn
                            btn-sm
                            btn-outline-primary
                            no-focus
                            font-size11
                            mr-2
                        ">
                    <i class="fas fa-plus mr-1"></i>
                    Add Connection
                </button>
            `);

        $addButton
            .off(
                "click.cabHubAddConnection"
            )
            .on(
                "click.cabHubAddConnection",
                () => {
                    this.onAddConnection();
                }
            );

        $buttonContainer
            .prepend(
                $addButton
            );
    }


    private customizeTableHeader():
        void {

        const tableId =
            this.tableConfig.tableId;

        const $wrapper =
            $(`#${tableId}_wrapper`);

        const $topControls =
            $wrapper.find(
                `.${tableId}-top-controls`
            );

        const $buttons =
            $topControls
                .find(
                    ".dt-buttons"
                )
                .detach();

        const $search =
            $topControls
                .find(
                    `.${tableId}-search-bar`
                )
                .detach();
        $search
            .addClass(
                "px-0"
        );

        const $actions =
            $(`
            <div class="
                d-flex
                align-items-center
                justify-content-between
                w-100
            ">
            </div>
        `);

        $actions.append(
            $search,
            $buttons
        );

        $topControls
            .removeClass(
                "row mx-0 align-items-center"
            )
            .addClass(
                "cab-hub-connections-table-top-controls " +
                "d-flex " +
                "align-items-center " +
                "w-100 " 
            )
            .empty()
            .append(
                $actions
            );

        $(
            `#${tableId}-filter-tab-container`
        ).remove();

        $(
            `#${tableId}-filter-container`
        ).remove();

        $(
            `#${tableId}-target-container`
        )
            .children("hr")
            .remove();
    }

    private renderProjectedDate(
        startDate: string,
        months: number,
        type: string
    ): string {

        if (!startDate) {
            return "";
        }

        const projectedDate =
            new Date(
                startDate
            );

        projectedDate.setMonth(
            projectedDate.getMonth() +
            months
        );

        if (
            type !==
            "display"
        ) {
            return projectedDate
                .toISOString();
        }

        return getDisplayDate(
            projectedDate
        );
    }
}


//Read Only CONNECTIONS table for Cab and Hub Views
export class CabHubReadOnlyConnectionsTable

{

    private readonly tableConfig:
        EditTableConfig;

    private readonly editTable:
        EditTable;

    private tableRenderer:
        TableRenderer;

    private pickLists:
        JsonItem[];

    private connectionList:
        CabHubConnectionEntity[];
  
    constructor(
        private readonly targetId: string,
        private readonly vm: CabHubTrackingPageVm,
      
    ) {
        this.tableConfig = {
            tableId:
                "cab-hub-readonly-connections-table",

            tableVarName:
                "connectionTable.editTable",

            propertyIdName:
                "Id",

            itemDisplayName:
                "Connections",

            isEditable:
                false,

            isMultiselect:
                false,

            editController:
                undefined,

            tableColumnGroups: [],

            filterTabs: [],

            columns:
                this.buildColumns(),

            sortOrder: [
                new EditTableSortColumn(
                    3,
                    "desc"
                )
            ]
        };

        this.editTable =
            new EditTable(
                this.tableConfig
            );
    }

    public initialize(): void {
        const html =
            this.editTable
                .generateHtml();

        $(`#${this.targetId}`)
            .empty()
            .html(html);

        this.connectionList =
            plainToClass(
                CabHubConnectionEntity,
                this.vm.Connections ?? []
            );

        this.pickLists =
            plainToClass(
                JsonItem,
                this.vm.PickLists ?? []
            );

        this.tableRenderer =
            new TableRenderer(
                this.pickLists
            );

        this.editTable.initialize(
            this.connectionList,
            this.pickLists
        );

        this.customizeTableHeader();
   
        setTimeout(
            () =>
                this.editTable
                    .resizeTable(),
            100
        );

    }
    public resize(): void {
        this.editTable
            .resizeTable();
    }

    private buildColumns():
        DataTables.ColumnSettings[] {

        return [
            {
                data:
                    "CabMemberUserId",

                title:
                    "CAB Member",

                className:
                    "general text-left " +
                    "font-size12 table-column-md",

                render:
                    (
                        data:
                            number
                    ): string => {

                        return this.tableRenderer
                            .renderDisplay(
                                data,
                                TableRenderType.Number,
                                "pl-cab-member"
                            );
                    }
            },
       
            {
                data:
                    "HubId",

                title:
                    "Hub",

                className:
                    "general text-left " +
                    "font-size12 nowrap",

                render:
                    (
                        data:
                            number
                    ): string => {

                        return this.tableRenderer
                            .renderDisplay(
                                data,
                                TableRenderType.Number,
                                "pl-short-hub"
                            );
                    }
            },
            {
                data:
                    "StatusId",

                title:
                    "Status",

                className:
                    "general text-center " +
                    "font-size12 nowrap",

                render:
                    (
                        data:
                            number,
                        type:
                            string
                    ): string => {

                        return this.renderStatus(
                            data,
                            type
                        );
                    }
            },
            {
                data:
                    "StartDate",

                title:
                    "Start Date",

                className:
                    "general text-left " +
                    "font-size12 nowrap",

                render:
                    (
                        data:
                            string,
                        type:
                            string
                    ): string => {

                        return this.renderDate(
                            data,
                            type
                        );
                    }
            },
            {
                data:
                    "EndDate",

                title:
                    "End Date",

                className:
                    "general text-left " +
                    "font-size12 nowrap",

                render:
                    (
                        data:
                            string,
                        type:
                            string
                    ): string => {

                        return this.renderDate(
                            data,
                            type
                        ) || "—";
                    }
            }
        ];
    }

    private customizeTableHeader():
        void {

        const tableId =
            this.tableConfig.tableId;

        const $wrapper =
            $(`#${tableId}_wrapper`);

        const $topControls =
            $wrapper.find(
                `.${tableId}-top-controls`
            );

        const $buttons =
            $topControls
                .find(
                    ".dt-buttons"
                )
                .detach();

        const $search =
            $topControls
                .find(
                    `.${tableId}-search-bar`
                )
                .detach();
        $search
            .addClass(
                "px-0"
            );
        const description =
            this.vm.Scope ===
                "cab-member"
                ? "List of connections you have with CONNECT Hubs."
                : "List of CAB member connections for your Hub.";

        const $description =
            $(`
            <div class="mb-3">
                ${description}
            </div>
        `);

        const $controls =
            $(`
            <div class="
                d-flex
                align-items-center
                justify-content-between
                w-100
            ">
            </div>
        `);

        const $actions =
            $(`
            <div class="
                d-flex
                align-items-center
                justify-content-end
                ml-auto
            ">
            </div>
        `);

        $actions.append(
            $buttons
        );

        $controls.append(
            $search,
            $actions
        );

        $topControls
            .removeClass(
                "row mx-0 align-items-center"
            )
            .addClass(
                "cab-hub-connections-table-top-controls " +
                "d-block " +
                "w-100 " 
            )
            .empty()
            .append(
                $description,
                $controls
            );

        $(
            `#${tableId}-filter-tab-container`
        ).remove();

        $(
            `#${tableId}-filter-container`
        ).remove();

        $(
            `#${tableId}-target-container`
        )
            .children("hr")
            .remove();
    }

    private renderStatus(
        data:
            number,
        type:
            string
    ): string {

        const display =
            this.tableRenderer
                .renderDisplay(
                    data,
                    TableRenderType.Number,
                    "pl-connection-status"
                );

        if (
            type !==
            "display"
        ) {
            return display;
        }

        const isActive =
            display
                .trim()
                .toLowerCase() ===
            "active";

        const className =
            isActive
                ? "cab-edit-table-active-pill"
                : "cab-edit-table-inactive-pill";

        return `
            <div class="${className}">
                ${display}
            </div>
        `;
    }
   
    private renderDate(
        data:
            string,
        type:
            string
    ): string {

        if (
            type !== "display" ||
            !data
        ) {
            return data ?? "";
        }

        return getDisplayDate(
            new Date(data)
        );
    }
}

// ACTIVE / AWAITING SURVEYS TABLE
export class CabHubActiveSurveysTable
{

    private readonly tableId =
        "active-surveys-table";

    private dataTable:
        any;

    constructor(
        private rows:
            CabHubActiveSurveyRow[]
    ) {
        this.rows =
            rows ?? [];
    }

    public initialize(): void {
        this.dataTable =
            $(`#${this.tableId}`)
                .DataTable({
                    data:
                        this.rows,

                    paging:
                        false,

                    searching:
                        true,

                    info:
                        false,

                    ordering:
                        true,

                    scrollX:
                        true,
                    
                    scrollCollapse:
                        true,
                    scrollY: '60vh',
                    autoWidth:
                        true,
                    dom:
                        '<"active-surveys-generated-controls d-flex align-items-center justify-content-between"fB>rt',
                    buttons: [
                        {
                            extend:
                                "csv",

                            text:
                                '<i class="fas fa-file-download"></i>',

                            titleAttr:
                                "CSV",

                            charset:
                                "utf-8"
                        }
                    ],
                    language: {
                        emptyTable:
                            "There are no active or awaiting surveys."
                    },

                    columns: [
                        {
                            data:
                                null,

                            title:
                                "Reporting Period",

                            className:
                                "text-left font-size12 nowrap",

                            render:
                                (
                                    data:
                                        CabHubActiveSurveyRow,
                                    type:
                                        string
                                ): string => {
                                    const display =
                                        this.renderMonthYear(
                                            data.ReportingMonth,
                                            data.ReportingYear
                                        );

                                    return type === "display"
                                        ? display
                                        : `${data.ReportingYear}-${data.ReportingMonth}`;
                                }
                        },
                        {
                            data:
                                "CabMemberName",

                            title:
                                "CAB Member",

                            className:
                                "text-left font-size12"
                        },
                        {
                            data:
                                "HubShortName",

                            title:
                                "Hub",

                            className:
                                "text-left font-size12 table-column-md"
                        },
                        {
                            data:
                                "CabSurveySubmitted",

                            title:
                                "CAB Survey",

                            className:
                                "text-center font-size12 nowrap",

                            render:
                                (
                                    submitted:
                                        boolean,
                                    type:
                                        string
                                ): string => {
                                    if (type !== "display") {
                                        return submitted
                                            ? "Complete"
                                            : "Awaiting";
                                    }

                                    return this.renderSurveyStatus(
                                        submitted
                                    );
                                }
                        },
                        {
                            data:
                                "HubSurveySubmitted",

                            title:
                                "Hub Survey",

                            className:
                                "text-center font-size12 nowrap",

                            render:
                                (
                                    submitted:
                                        boolean,
                                    type:
                                        string
                                ): string => {
                                    if (type !== "display") {
                                        return submitted
                                            ? "Complete"
                                            : "Awaiting";
                                    }

                                    return this.renderSurveyStatus(
                                        submitted
                                    );
                                }
                        }
                    ],

                    order: [
                        [
                            0,
                            "desc"
                        ]
                    ]
                });

        const $controls =
            $(`#${this.tableId}`)
                .closest(".dataTables_wrapper")
                .find(
                    ".active-surveys-generated-controls"
                );

        $("#active-surveys-search-host")
            .empty()
            .append(
                $controls.find(
                    ".dataTables_filter"
                )
            );

        $("#active-surveys-actions-host")
            .empty()
            .append(
                $controls.find(
                    ".dt-buttons"
                )
            );

        $controls.remove();
        this.dataTable
            .on(
                "draw.dt",
                () => {
                    this.updateCount();
                }
            );
      
        this.updateCount();
    }

    public update(
        rows:
            CabHubActiveSurveyRow[]
    ): void {
        this.rows =
            rows ?? [];

        if (!this.dataTable) {
            return;
        }

        this.dataTable
            .clear();

        this.dataTable
            .rows
            .add(
                this.rows
            );

        this.dataTable
            .draw();
        
    }

    public resize(): void {
        if (!this.dataTable) {
            return;
        }

        this.dataTable
            .columns
            .adjust();
    }

    private updateCount(): void {
        if (!this.dataTable) {
            return;
        }

        const count =
            this.dataTable
                .rows({
                    search:
                        "applied"
                })
                .count();

        $("#active-survey-count")
            .text(
                count === 1
                    ? "1 survey awaiting completion"
                    : `${count} surveys awaiting completion`
            );
    }

    private renderSurveyStatus(
        submitted:
            boolean
    ): string {
        const className =
            submitted
                ? "cab-edit-table-active-pill"
                : "cab-detail-table-inactive-pill";

        const display =
            submitted
                ? "Complete"
                : "Awaiting";

        return `
            <span class="${className}">
                ${display}
            </span>
        `;
    }

    private renderMonthYear(
        month:
            number,
        year:
            number
    ): string {
        if (
            !month ||
            !year
        ) {
            return "—";
        }

        return new Date(
            year,
            month - 1,
            1
        ).toLocaleDateString(
            "en-US",
            {
                month:
                    "long",

                year:
                    "numeric"
            }
        );
    }
}

// COMPLETED SURVEY TABLE: read only, scoped to admin, cab-member, hub

export class CabHubCompletedSurveysTable

implements IFilter{

    private readonly tableId =
        "completed-surveys-table";

    private columnVisibilityController:
        TableColumnVisibilityControllerV2;

    private dataTable:
        any;

    private tableRenderer:
        TableRenderer;

    private readonly surveyTypeFilterId =
        "#completed-surveys-type-filter";

    private readonly hubFilterId =
        "#completed-surveys-hub-filter";

    private readonly reportingPeriodFilterId =
        "#completed-surveys-reporting-period-filter";

    constructor(
        private rows:
            CabHubCompletedSurveyRow[],
        private readonly scope:
            CabHubScope,
        private readonly pickLists:
            JsonItem[]

    ) {
        this.rows =
            rows ?? [];
        this.pickLists =
            pickLists ?? [];
    }

    public initialize(): void {
        $(`#${this.tableId}`)
            .on(
                "click",
                ".js-view-completed-survey",
                e => {

                    const surveyId =
                        Number(
                            $(e.currentTarget)
                                .data("survey-id")
                        );

                    const surveyType =
                        String(
                            $(e.currentTarget)
                                .data("survey-type")
                        );

                    const survey =
                        this.rows.find(
                            row =>
                                row.SurveyId === surveyId &&
                                row.SurveyType === surveyType
                        );

                    if (!survey) {
                        return;
                    }

                    this.openCompletedSurvey(
                        survey
                    );
                }
            );

        this.tableRenderer =
            new TableRenderer(
                this.pickLists
            );


        this.dataTable =
            $(`#${this.tableId}`)
                .DataTable({
                    data:
                        this.rows,

                    searching:
                        true,

                    dom:
                        '<"completed-surveys-generated-controls"fB>rt',
                    buttons: [
                        {
                            extend:
                                "csv",

                            text:
                                '<i class="fas fa-file-download"></i>',

                            titleAttr:
                                "CSV",

                            charset:
                                "utf-8",

                            exportOptions: {
                                columns:
                                    ":not(.no-export)"
                            }
                        }
                    ],

                    info:
                        false,

                    ordering:
                        true,

                    scrollX:
                        true,
                    scrollCollapse:
                        true,
                    scrollY: '60vh',
                    autoWidth:
                        true,

                    language: {
                        emptyTable:
                            "No completed surveys are available."
                    },

                    columns:
                        this.buildColumns(),

                    order: [
                        [
                            4,
                            "desc"
                        ]
                    ]
                });

//Admin only filters
        if (
            this.scope === "admin"
        ) {
            this.initializeFilters();
        }
        const $controls =
            $(`#${this.tableId}`)
                .closest(".dataTables_wrapper")
                .find(
                    ".completed-surveys-generated-controls"
                );

        $("#completed-surveys-search-host")
        
            .append(
                $controls.find(
                    ".dataTables_filter"
                )
            );

        $("#completed-surveys-actions-host")
            .append(
                $controls.find(
                    ".dt-buttons"
                )
            );

        $controls.remove();

        this.columnVisibilityController =
            new TableColumnVisibilityControllerV2(
                `#${this.tableId}`,
                "#completed-surveys-column-select",
                [
                    new TableColumnGroup(
                        "Standard Columns",
                        true,
                        [],
                        ""
                    ),
                    new TableColumnGroup(
                        "Advanced Survey Details",
                        false,
                        [],
                        "advanced-survey-column"
                    )
                ],
                "completed-surveys"
            );
        
        this.updateCount();
    }
    private initializeFilters():
        void {

        const surveyTypes =
            (
                this.pickLists.find(
                    item =>
                        item.Id ===
                        "pl-completed-survey-type"
                )?.Json ?? []
            )
                .map(
                    (item: PickListItem) =>
                        item.Value
                );

        const hubs =
            (
                this.pickLists.find(
                    item =>
                        item.Id ===
                        "pl-completed-hub"
                )?.Json ?? []
            )
                .map(
                    (item: PickListItem) =>
                        item.Value
                );

        const reportingPeriods =
            (
                this.pickLists.find(
                    item =>
                        item.Id ===
                        "pl-completed-reporting-period"
                )?.Json ?? []
            )
                .map(
                    (item: PickListItem) =>
                        item.Value
                );

        InitializeFilterDropdown(
            this.surveyTypeFilterId,
            surveyTypes,
            this
        );

        InitializeFilterDropdown(
            this.hubFilterId,
            hubs,
            this
        );

        InitializeFilterDropdown(
            this.reportingPeriodFilterId,
            reportingPeriods,
            this
        );
    }
    public triggerFilter():
        void {

        const selectedTypes =
            GetSelectedDropdownValues(
                this.surveyTypeFilterId
            ) as string[];

        const selectedHubs =
            GetSelectedDropdownValues(
                this.hubFilterId
            ) as string[];

        const selectedReportingPeriods =
            GetSelectedDropdownValues(
                this.reportingPeriodFilterId
            ) as string[];

        const filteredRows =
            this.rows
                .filter(
                    row => {

                        return (
                            selectedTypes.includes(
                                row.SurveyType
                            ) &&
                            selectedHubs.includes(
                                row.HubShortName
                            ) &&
                            selectedReportingPeriods.includes(
                                this.getReportingPeriod(
                                    row
                                )
                            )
                        );
                    }
                );

        this.dataTable
            .clear();

        this.dataTable
            .rows
            .add(
                filteredRows
            );

        this.dataTable
            .draw();

        this.updateCount();
    }

    private getReportingPeriod(
        row:
            CabHubCompletedSurveyRow
    ): string {

        return (
            GetMonthFromNumber(
                row.ReportingMonth
            ) +
            " " +
            row.ReportingYear
        );
    }
    public update(
        rows:
            CabHubCompletedSurveyRow[]
    ): void {
        this.rows =
            rows ?? [];

        if (!this.dataTable) {
            return;
        }

        this.dataTable
            .clear();

        this.dataTable
            .rows
            .add(
                this.rows
            );

        this.dataTable
            .draw();

        this.updateCount();
    }

    public resize(): void {
        if (!this.dataTable) {
            return;
        }

        this.dataTable
            .columns
            .adjust();
    }

    private updateCount(): void {
        const count =
            this.rows.length;

        $("#completed-survey-count")
            .text(
                count === 1
                    ? "1 completed survey"
                    : `${count} completed surveys`
            );
    }
    private buildColumns():
        DataTables.ColumnSettings[] {

        const columns:
            DataTables.ColumnSettings[] = [];

        if (
            this.scope === "admin"
        ) {
            columns.push({
                data:
                    "SurveyType",

                title:
                    "Survey Type",

                className:
                    "text-left font-size12 nowrap"
            });
        }

        columns.push(
            {
                data:
                    null,

                title:
                    "Month / Year",

                className:
                    "text-left font-size12 nowrap",

                render:
                    (
                        row:
                            CabHubCompletedSurveyRow,
                        type:
                            string
                    ): string => {

                        const display =
                            this.getReportingPeriod(
                                row
                            );

                        return type === "display"
                            ? display
                            : `${row.ReportingYear}-${row.ReportingMonth}`;
                    }
            },
            {
                data:
                    "HubShortName",

                title:
                    "Hub",

                className:
                    "text-left font-size12 nowrap"
            },
            {
                data:
                    "CabMemberName",

                title:
                    "CAB Member",

                className:
                    "text-left font-size12 nowrap"
            },
            {
                data:
                    "MetThisMonth",

                title:
                    "Met This Month",

                className:
                    "text-center font-size12 nowrap",

                render:
                    (
                        value:
                            boolean,
                        type:
                            string
                    ): string => {

                        const text =
                            value
                                ? "Yes"
                                : "No";

                        if (type !== "display") {
                            return text;
                        }

                        return `
                <span class="
                    ${value
                            ? "cab-edit-table-active-pill"
                            : "cab-detail-table-inactive-pill"}
                ">
                    ${text}
                </span>
            `;
                    }
            },
            {
                data:
                    "SatisfactionRatingId",

                title:
                    "Satisfaction",

                className:
                    "text-left font-size12 nowrap",

                render:
                    (
                        data:
                            number
                    ): string => {

                        return this.tableRenderer
                            .renderDisplay(
                                data,
                                TableRenderType.Number,
                                "SatisfactionRating"
                            );
                    }
            },
            {
                data:
                    "SupportRequested",

                title:
                    "Support Requested",

                className:
                    "text-center font-size12 nowrap",

                render:
                    (
                        value:
                            boolean,
                        type:
                            string
                    ): string => {

                        const text =
                            value
                                ? "Yes"
                                : "No";

                        if (type !== "display") {
                            return text;
                        }

                        return `
                <span class="
                    ${value
                            ? "cab-edit-table-active-pill"
                            : "cab-detail-table-inactive-pill"}
                ">
                    ${text}
                </span>
            `;
                    }
            },
            {
                data:
                    "SubmittedDate",

                title:
                    "Submitted",

                className:
                    "text-left font-size12 nowrap",

                render:
                    (
                        value:
                            string,
                        type:
                            string
                    ): string => {

                        if (!value) {
                            return "";
                        }

                        return type === "display"
                            ? getDisplayDate(
                                new Date(value)
                            )
                            : value;
                    }
            },
            {
                data:
                    "SurveyId",

                title:
                    "View",

                className:
                    "text-center font-size12 nowrap no-export",

                orderable:
                    false,

                render:
                    (
                        value:
                            number,
                        type:
                            string,
                        row:
                            CabHubCompletedSurveyRow
                    ): string => {

                        if (type !== "display") {
                            return `${value ?? ""}`;
                        }
                        //need to open modal view of survey on hub and cab
                        return `
                        <button type="button"
                                class="btn btn-sm font-size14 js-view-completed-survey"
                                data-survey-id="${value}"
                                data-survey-type="${row.SurveyType}">
                            View
                        </button>
                    `;
                    }
            },
            {
                data:
                    "NotMetExplanation",

                title:
                    "Not Met Explanation",

                className:
                    "text-left font-size12 nowrap advanced-survey-column"
            },
            {
                data:
                    "HoursWorked",

                title:
                    "Hours Worked",

                className:
                    "text-left font-size12 nowrap advanced-survey-column"
            },
            {
                data:
                    "AdditionalHoursCompensationRate",

                title:
                    "Compensation Rate",

                className:
                    "text-left font-size12 nowrap advanced-survey-column"
            },
            {
                data:
                    "AnticipatedHoursNextMonthId",

                title:
                    "Anticipated Hours Next Month",

                className:
                    "text-left font-size12 nowrap advanced-survey-column"
            },
            {
                data:
                    "ConsultationTypeIds",

                title:
                    "Consultation Types",

                className:
                    "text-left font-size12 nowrap advanced-survey-column",

                render:
                    (
                        value:
                            string,
                        type:
                            string,
                        row:
                            CabHubCompletedSurveyRow
                    ): string => {

                        const pickListId =
                            row.SurveyType === "CAB"
                                ? "CabConsultationType"
                                : "HubConsultationType";

                        return this.tableRenderer
                            .renderDisplay(
                                value,
                                TableRenderType.PipePathSeparatedIds,
                                pickListId
                            );
                    }
            },
            {
                data:
                    "OtherConsultationType",

                title:
                    "Other Consultation Type",

                className:
                    "text-left nowrap font-size12 advanced-survey-column"
            },
            {
                data:
                    "WorkDescription",

                title:
                    "Work Description",

                className:
                    "text-left font-size12 nowrap advanced-survey-column"
            },
            {
                data:
                    "SatisfactionExplanation",

                title:
                    "Satisfaction Explanation",

                className:
                    "text-left font-size12 nowrap advanced-survey-column"
            },
            {
                data:
                    "SupportRequestExplanation",

                title:
                    "Support Request Explanation",

                className:
                    "text-left nowrap font-size12 col-lg advanced-survey-column"
            },
            {
                data:
                    "TrainingNeededId",

                title:
                    "Training Needed",

                className:
                    "text-left font-size12 nowrap advanced-survey-column"
            },
            {
                data:
                    "TrainingDescription",

                title:
                    "Training Description",

                className:
                    "text-left font-size12 nowrap col-lg advanced-survey-column"
            },
            {
                data:
                    "SubmittedByName",

                title:
                    "Submitted By",

                className:
                    "text-left font-size12 nowrap advanced-survey-column"
            }
        );

        return columns;
    }


    //Survey View modal
    private formatSurveyValue(
        value:
            any
    ): string {

        if (
            value === null ||
            value === undefined ||
            value === ""
        ) {
            return "—";
        }

        return String(
            value
        );
    }
    private renderSurveyPill(
        value:
            string
    ): string {

        const normalizedValue =
            (value ?? "")
                .trim()
                .toLowerCase();

        let pillClass =
            "cab-view-table-inactive-pill";

        if (
            normalizedValue === "yes" ||
            normalizedValue === "satisfied" ||
            normalizedValue === "extremely satisfied"
        ) {
            pillClass =
                "cab-edit-table-active-pill";
        }
        else if (
            normalizedValue === "not sure" ||
            normalizedValue === "neither satisfied or dissatisfied"
        ) {
            pillClass =
                "cab-detail-table-neutral-pill";
        }

        return `
        <span class="${pillClass}">
            ${this.formatSurveyValue(
            value
        )}
        </span>
    `;
    }
    private openCompletedSurvey(
        survey:
            CabHubCompletedSurveyRow
    ): void {

        const satisfaction =
            this.tableRenderer
                .renderDisplay(
                    survey.SatisfactionRatingId,
                    TableRenderType.Number,
                    "SatisfactionRating"
                );

        const anticipatedHours =
            this.tableRenderer
                .renderDisplay(
                    survey.AnticipatedHoursNextMonthId,
                    TableRenderType.Number,
                    "YesNoNotSure"
                );

        const trainingNeeded =
            this.tableRenderer
                .renderDisplay(
                    survey.TrainingNeededId,
                    TableRenderType.Number,
                    "YesNoNotSure"
                );

        const consultationTypes =
            this.tableRenderer
                .renderDisplay(
                    survey.ConsultationTypeIds,
                    TableRenderType.PipePathSeparatedIds,
                    survey.SurveyType === "CAB"
                        ? "CabConsultationType"
                        : "HubConsultationType"
            );

        const submittedBy =
            survey.SubmittedByName;

        $("#completed-survey-modal-title")
            .text(
                `${survey.SurveyType} Survey Response`
            );

        $("#completed-survey-modal-context")
            .text(
                `${survey.CabMemberName} | ` +
                `${survey.HubShortName} | ` +
                `${this.getReportingPeriod(
                    survey
                )}`
            );

        $("#completed-survey-detail-container")
            .html(`
            <div class="row">

                ${this.renderSurveyDetail(
                "Survey Type",
                survey.SurveyType
            )}

                ${this.renderSurveyDetail(
                "CAB Member",
                survey.CabMemberName
            )}

                ${this.renderSurveyDetail(
                "Hub",
                survey.HubName
            )}

                ${this.renderSurveyDetail(
                "Reporting Period",
                this.getReportingPeriod(
                    survey
                )
            )}

            ${this.renderSurveyDetail(
                "Met This Month",
                this.renderSurveyPill(
                    survey.MetThisMonth
                        ? "Yes"
                        : "No"
                ),
                true
            )}
                ${this.renderSurveyDetail(
                "Not Met Explanation",
                survey.NotMetExplanation
            )}

                ${this.renderSurveyDetail(
                "Hours Worked",
                survey.HoursWorked
            )}

            ${this.renderSurveyDetail(
                "Additional Hours Compensation Rate",
                survey.AdditionalHoursCompensationRate != null &&
                    survey.AdditionalHoursCompensationRate > 0
                    ? `$${survey.AdditionalHoursCompensationRate}/hr`
                    : null
            )}

                ${this.renderSurveyDetail(
                "Anticipated Hours Next Month",
                anticipatedHours
            )}

                ${this.renderSurveyDetail(
                "Consultation Types",
                consultationTypes
            )}

                ${this.renderSurveyDetail(
                "Other Consultation Type",
                survey.OtherConsultationType
            )}

                ${this.renderSurveyDetail(
                "Work Description",
                survey.WorkDescription
            )}

           ${this.renderSurveyDetail(
               "Satisfaction",
                satisfaction
             
           )}

                ${this.renderSurveyDetail(
                "Satisfaction Explanation",
                survey.SatisfactionExplanation
            )}

            ${this.renderSurveyDetail(
                "Support Requested",
                this.renderSurveyPill(
                    survey.SupportRequested
                        ? "Yes"
                        : "No"
                ),
                true
            )}

                ${this.renderSurveyDetail(
                "Support Request Explanation",
                survey.SupportRequestExplanation
            )}

            ${this.renderSurveyDetail(
                "Training Needed",
                this.renderSurveyPill(
                    trainingNeeded
                ),
                true
            )}

                ${this.renderSurveyDetail(
                "Training Description",
                survey.TrainingDescription
            )}

             ${this.renderSurveyDetail(
                 "Submitted By",
                 submittedBy
             )}

                ${this.renderSurveyDetail(
                "Submitted",
                survey.SubmittedDate
                    ? getDisplayDate(
                        new Date(
                            survey.SubmittedDate
                        )
                    )
                    : null
            )}

            </div>
        `);

        $("#completed-survey-modal")
            .modal(
                "show"
            );
    }

    private renderSurveyDetail(
        label:
            string,
        value:
            any,
        isHtml:
            boolean = false
    ): string {

        const displayValue =
            isHtml
                ? value
                : this.formatSurveyValue(
                    value
                );

        return `
        <div class="col-12 col-md-6 py-3 completed-survey-detail">
            <div class="completed-survey-detail-label">
                ${label}
            </div>

            <div class="completed-survey-detail-value">
                ${displayValue}
            </div>
        </div>
    `;
    }

}